import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";

import {Button, Card, Form, Input, InputNumber, notification, Select} from 'antd';

import {getProduct, updateProduct} from './actions';
import {getCategoryTree} from "../Category/actions";
import {getDescriptionFromError} from "../utils/errors";
import {getBrands} from "../Brand/actions";
import {getSuppliers} from "../Supplier/actions";
import {getRegulatoryReportingTypes} from "../RegulatoryReporting/actions";
import {formItemLayout} from "../utils/style";
import UploadProductImage from "./UploadProductImage";
import units from "./units";
import SelectCategoryTree from "../Category/SelectCategoryTree";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateProductForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    getProduct: PropTypes.func.isRequired,
    productLoading: PropTypes.bool.isRequired,
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func.isRequired,
    getCategoryTree: PropTypes.func.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    categoryTree: PropTypes.object.isRequired,
    getBrands: PropTypes.func.isRequired,
    brands: PropTypes.array.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    suppliers: PropTypes.array.isRequired,
    getRegulatoryReportingTypes: PropTypes.func.isRequired,
    regulatoryReportingTypes: PropTypes.array.isRequired,
    units: PropTypes.array.isRequired,
  };

  static defaultProps = {
    units
  };

  state = {};

  componentDidMount() {
    this._load();
    this._loadProduct();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this._load();
    if (this.props.match.params.productId !== prevProps.match.params.productId) this._loadProduct();
  }

  _load() {
    const {dispensaryId} = this.props;
    this.props.getCategoryTree({dispensaryId});
    this.props.getBrands({dispensaryId});
    this.props.getSuppliers({dispensaryId});
    this.props.getRegulatoryReportingTypes();
  }

  _loadProduct() {
    const {productId} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId, match} = this.props;
    const {productId} = decodeParams(match.params);
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async(err, values) => {
      if (err) return;
      try {
        const product = {...values, dispensaryId, productId};
        await this.props.updateProduct(product);
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  _getUnitOfMeasureClassFor(regulatoryReportingTypeId) {
    const {regulatoryReportingTypes} = this.props;
    const found = regulatoryReportingTypes.find(x => x.regulatoryReportingTypeId === regulatoryReportingTypeId);
    return (found && found.unitOfMeasureClass) || null;
  }

  _onRegulatoryReportingTypeChange = (value) => {
    const {form: {getFieldValue, setFieldsValue}, units} = this.props;
    const newUnitOfMeasureClass = this._getUnitOfMeasureClassFor(value);
    const unitValue = getFieldValue('unit');
    const unit = unitValue && units.find(x => x.value === unitValue);
    if (unit && unit.unitOfMeasureClass !== newUnitOfMeasureClass) {
      setFieldsValue({unit: null});
    }
  };

  render() {
    const {
      brands, categoryTree, form: {getFieldDecorator, getFieldsError, getFieldValue, isFieldTouched}, product,
      productLoading, suppliers, regulatoryReportingTypes, units,
    } = this.props;
    const {
      categoryId, brandId, regulatoryReportingTypeId, name, description, packageQuantity, salePrice, supplierId,
      imageUri, supplierOrderCode, limitValue, unit
    } = product;
    const selectedUnitOfMeasureClass = this._getUnitOfMeasureClassFor(isFieldTouched('regulatoryReportingTypeId') ? getFieldValue('regulatoryReportingTypeId') : regulatoryReportingTypeId);
    const availableUnits = (selectedUnitOfMeasureClass && units.filter(x => x.unitOfMeasureClass === selectedUnitOfMeasureClass)) || units;
    return (
      <Card title="Update Product">
        <Form onSubmit={e => e.preventDefault()}>
          <FormItem
            {...formItemLayout}
            label="Category"
          >
            {getFieldDecorator('categoryId', {
              initialValue: categoryId,
              rules: [{
                required: true,
                message: 'Category is required'
              }]
            })(
              <SelectCategoryTree tree={categoryTree} hideNone />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Brand"
          >
            {getFieldDecorator('brandId', {
              initialValue: brandId
            })(
              <Select>
                <Option key="addProduct-brandId-null" value={null}>None</Option>
                {brands.map(brand =>
                  <Option key={brand.brandId} value={brand.brandId}>{brand.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Supplier"
          >
            {getFieldDecorator('supplierId', {
              initialValue: supplierId
            })(
              <Select>
                <Option key="addProduct-supplierId-null" value={null}>None</Option>
                {suppliers.map(supplier =>
                  <Option key={supplier.supplierId} value={supplier.supplierId}>{supplier.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Regulatory Reporting Type"
          >
            {getFieldDecorator('regulatoryReportingTypeId', {
              initialValue: regulatoryReportingTypeId
            })(
              <Select onChange={this._onRegulatoryReportingTypeChange}>
                <Option key="regulatory-reporting-type-none" value={null}>NONE</Option>
                {regulatoryReportingTypes.map((rrt) =>
                  <Option key={rrt.regulatoryReportingTypeId} value={rrt.regulatoryReportingTypeId}>{rrt.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: description
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Package quantity"
          >
            {getFieldDecorator('packageQuantity', {
              initialValue: packageQuantity,
              rules: [{
                required: true,
                message: 'Package quantity is required'
              }, {
                validator(rule, value, callback) {
                  const errors = [];
                  if (value !== '' && value <= 0) {
                    errors.push(new Error('must be greater than 0'));
                  }
                  callback(errors);
                }
              }]
            })(
              <InputNumber precision={3} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Unit"
          >
            {getFieldDecorator('unit', {
              initialValue: unit,
              rules: [{
                required: true
              }]
            })(
              <Select>
                {availableUnits
                  .map(({value, display}) => <Option key={value} value={value}>{display}</Option>)
                }
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Value counting towards daily limit"
          >
            {getFieldDecorator('limitValue', {
              initialValue: (limitValue === null && !!getFieldValue('regulatoryReportingTypeId')) ? packageQuantity : limitValue,
              rules: [
                {type: 'number', min: 0, required: !!getFieldValue('regulatoryReportingTypeId')}
              ]
            })(
              <InputNumber precision={3} />
            )}
            &nbsp;gram(s)
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Sale Price"
          >
            {getFieldDecorator('salePrice', {
              initialValue: salePrice,
              rules: [{
                required: true,
                message: 'Sale price is required'
              }, {
                type: 'number',
                min: 0,
                message: 'Must be a positive number'
              }]
            })(
              <InputNumber precision={3} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Supplier Order Code"
          >
            {getFieldDecorator('supplierOrderCode', {initialValue: supplierOrderCode})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Image"
          >
            {getFieldDecorator('imageUri', {initialValue: imageUri})(
              <UploadProductImage />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="button"
                onClick={this.handleSubmit}
                disabled={productLoading || hasErrors(getFieldsError())}
              >
                Update Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateProductPage = Form.create()(UpdateProductForm);

const mapStateToProps = state => ({
  productLoading: state.product.productLoading,
  product: state.product.product || {},
  dispensaryId: state.dispensary.selectedDispensaryId,
  categoryTree: state.category.categoryTree,
  brands: state.brand.brands,
  suppliers: state.supplier.suppliers,
  regulatoryReportingTypes: state.regulatoryReportingType.regulatoryReportingTypes,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getProduct,
  updateProduct,
  getCategoryTree,
  getBrands,
  getSuppliers,
  getRegulatoryReportingTypes,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProductPage);



// WEBPACK FOOTER //
// ./src/Product/UpdateProductPage.js